export default "__VITE_ASSET__n_tQ4c37__"